import { useState } from "react";
import { Button } from "../../../../shared/components/ui/button.js";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../../shared/components/ui/dialog.js";
import { Textarea } from "../../../../shared/components/ui/textarea.js";

/**
 * Botões Aprovar / Recusar no card de `notification.sale.reopen-requested`.
 * Presentacional: HTTP fica no Inbox via `useSaleReopen`.
 *
 * @param {Object} props
 * @param {() => void|Promise<void>} props.onApprove
 * @param {(reason?: string) => void|Promise<void>} props.onReject
 * @param {boolean} [props.disabled]
 * @param {boolean} [props.isBusy]
 * @param {boolean} [props.canSubmit]
 */
export function NotificationReopenActions({
  onApprove,
  onReject,
  disabled = false,
  isBusy = false,
  canSubmit = true,
}) {
  const [rejectOpen, setRejectOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");

  const locked = disabled || isBusy || !canSubmit;

  return (
    <>
      <div
        className="mt-3 flex gap-2"
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
      >
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="flex-1"
          disabled={locked}
          onClick={() => setRejectOpen(true)}
        >
          Recusar
        </Button>
        <Button
          type="button"
          size="sm"
          className="flex-1"
          disabled={locked}
          onClick={() => onApprove?.()}
        >
          {isBusy ? "Processando..." : "Aprovar"}
        </Button>
      </div>

      {!canSubmit && !disabled ? (
        <p className="mt-2 text-xs text-muted-foreground">
          Sem ID do solicitante (notifyUserId). Ação indisponível até a API
          enviar o campo.
        </p>
      ) : null}

      <Dialog open={rejectOpen} onOpenChange={setRejectOpen}>
        <DialogContent
          onClick={(event) => event.stopPropagation()}
          onPointerDownOutside={(event) => event.stopPropagation()}
        >
          <DialogHeader>
            <DialogTitle>Recusar reabertura</DialogTitle>
            <DialogDescription>
              A venda não será alterada. O solicitante será notificado.
            </DialogDescription>
          </DialogHeader>
          <Textarea
            value={rejectReason}
            onChange={(event) => setRejectReason(event.target.value)}
            placeholder="Motivo opcional da recusa"
            rows={3}
          />
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              disabled={isBusy}
              onClick={() => setRejectOpen(false)}
            >
              Cancelar
            </Button>
            <Button
              type="button"
              disabled={isBusy || !canSubmit}
              onClick={async () => {
                await onReject?.(rejectReason.trim() || undefined);
                setRejectOpen(false);
                setRejectReason("");
              }}
            >
              Confirmar recusa
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
